import { render, staticRenderFns } from "./serviceanalysisreport.vue?vue&type=template&id=e670e0b0&"
import script from "./serviceanalysisreport.vue?vue&type=script&lang=js&"
export * from "./serviceanalysisreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports